import React, { useState, useEffect } from 'react';

import './DesignComponent.css'; // Custom styles
import Draggable1 from 'react-draggable';
import { ResizableBox } from 'react-resizable';
import 'react-resizable/css/styles.css';
import './DesignComponent.css'; // Custom styles
import Popup from './Modules/Popup';
import MediaEditPopup from './Modules/MediaPopup';
import TextMediaPopup from './Modules/TextMediaPopup';
import { CreateLayouthooks } from '../../Helper/LayoutHelper';
import { create } from 'xmlbuilder2';
import { toast } from 'react-toastify';
import { LayoutListhooks } from '../../Helper/LayoutHelper';
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { GetTypeContentListhooks } from '../../Helper/ContentHelper';
import { ResolutionListhooks } from '../../Helper/ResolutionHelper';
import { LayoutGetbyIdhooks } from '../../Helper/LayoutHelper';
import WebsitePopup from './Modules/WebsitePopup';
import ClockMediaPopup from './Modules/ClockMediaPopup';
import YoutubeMediaPopup from './Modules/YoutubeMediaPopup';
import RSSFeedPopup from './Modules/RSSFeedPopup';
import { Link } from 'react-router-dom';
import { FILE_BASE_URL } from '../../Config/constants';
import LiveStreamPopup from './Modules/LiveStreamPopup';
import CountdownPopup from './Modules/CountdownPopup';
import CounterPopup from './Modules/CounterPopup';
import DateTimePopup from './Modules/DateTimePopup';
import HtmlPopup from './Modules/HTMLPopup';
import QRCodePopup from './Modules/QRCodePopup';
import WeatherPopup from './Modules/WeatherPopup';

function parseLayoutXML(xmlString) {
    const parser = new DOMParser();
    const xmlDoc = parser.parseFromString(xmlString, 'text/xml');

    const layoutElement = xmlDoc.querySelector('layout');
    const layout = {
        width: parseInt(layoutElement.getAttribute('width')),
        height: parseInt(layoutElement.getAttribute('height')),
        duration: parseInt(layoutElement.getAttribute('dur')),
    };

    const regionElements = xmlDoc.querySelectorAll('region');
    const regions = Array.from(regionElements).map(regionElement => {
        const region = {
            class: regionElement.getAttribute('class'),
            width: parseInt(regionElement.getAttribute('width')),
            height: parseInt(regionElement.getAttribute('height')),
            top: parseInt(regionElement.getAttribute('top')),
            left: parseInt(regionElement.getAttribute('left')),
            color: regionElement.getAttribute('color'),
            repeat: regionElement.getAttribute('repeat') === 'true',
            bgcolor: regionElement.getAttribute('bgcolor'),
            media: [],
        };

        const mediaElements = regionElement.querySelectorAll('media');
        region.media = Array.from(mediaElements).map(mediaElement => {
            const type = mediaElement.getAttribute('type');
            const base = {
                type,
                name: mediaElement.getAttribute('name'),
                title: mediaElement.getAttribute('title'),
                duration: parseInt(mediaElement.getAttribute('duration')),
                size: parseInt(mediaElement.getAttribute('size')),
                color: mediaElement.getAttribute('color'),
                behave: mediaElement.getAttribute('behave'),
                text: mediaElement.getAttribute('text'),
                id: mediaElement.getAttribute('id'),
                maxItems: mediaElement.getAttribute('maxItems'),
            };

            if (type === 'Clock') {
                return {
                    ...base,
                    style: mediaElement.getAttribute('style') || 'Digital',
                    format: mediaElement.getAttribute('format') || 'HH:mm:ss',
                    offsetMinutes: parseInt(mediaElement.getAttribute('offsetMinutes')) || 0,
                    timeZone: mediaElement.getAttribute('timeZone') || 'Local',
                    showSeconds: mediaElement.getAttribute('showSeconds') === 'true'
                };
            }

            if (type === 'YouTube') {
                return {
                    ...base,
                    url: mediaElement.getAttribute('url'),
                    autoplay: mediaElement.getAttribute('autoplay') || 'false',
                    streamType: mediaElement.getAttribute('streamType'),
                    mute: mediaElement.getAttribute('mute'),
                    showControls: mediaElement.getAttribute('showControls') || 'false',
                    fitMode: mediaElement.getAttribute('fitMode'),
                    fullscreen: parseInt(mediaElement.getAttribute('fullscreen')) || 'false',
                };
            }

            if (type === 'LiveStream') {
                return {
                    ...base,
                    url: mediaElement.getAttribute('url'),
                    autoplay: mediaElement.getAttribute('autoplay') || 'false',
                    fullscreen: parseInt(mediaElement.getAttribute('fullscreen')) || 'false',
                    duration: parseInt(mediaElement.getAttribute('duration')),
                };
            }

            if (type === 'Countdown') {
                return {
                    ...base,
                    targetDate: mediaElement.getAttribute('targetDate'),
                    message: mediaElement.getAttribute('message'),
                    expiredMessage: mediaElement.getAttribute('expiredMessage'),
                    showDaysOnly: mediaElement.getAttribute('showDaysOnly') || 'false',
                    duration: parseInt(mediaElement.getAttribute('duration')),
                };
            }

            if (type === 'Counter') {
                return {
                    ...base,
                    startValue: mediaElement.getAttribute('startValue'),
                    endValue: mediaElement.getAttribute('endValue'),
                    step: mediaElement.getAttribute('step'),
                    direction: mediaElement.getAttribute('direction'),
                    prefix: mediaElement.getAttribute('prefix'),
                    suffix:mediaElement.getAttribute('suffix')
                };
            }

            return base;
        });

        return region;
    });

    return { layout, regions };
}

function DesignComponent(props) {
    const [resolution, setResolution] = useState('');
    const [parsedLayout, setParsedLayout] = useState(null);
    const [CurrentRegionMedia, SetCurrentRegionMedia] = useState([]);
    const [mediaimages, Setmediaimages] = useState('');
    const [mediavideos, Setmediavideos] = useState('');
    const [currentpopupMedia, SetcurrentpopupMedia] = useState(null);
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [isEditPopupVisible, setIsEditPopupVisible] = useState(false);
    const [RegionIndex, SetRegionIndex] = useState(null);
    const [editingMedia, setEditingMedia] = useState(null);
    const [isTextPopupVisible, setIsTextPopupVisible] = useState(false); // New state for text popup
    const [isWebsitePopupVisible, setIsWebsitePopupVisible] = useState(false); // New state for Website popup
    const [WebsiteMedia, setWebsiteMedia] = useState(null); // New state for text media  


    const [isLiveStreamPopupVisible, setIsLiveStreamPopupVisible] = useState(false);
    const [LiveStreamMedia, setLiveStreamMedia] = useState(null);

    const [isCountdownPopupVisible, setIsCountdownPopupVisible] = useState(false);
    const [CountdownMedia, setCountdownMedia] = useState(null);

    const [isCounterPopupVisible, setIsCounterPopupVisible] = useState(false);
    const [CounterMedia, setCounterMedia] = useState(null);

    const [isDateTimePopupVisible, setIsDateTimePopupVisible] = useState(false);
    const [DateTimeMedia, setDateTimeMedia] = useState(null);

    const [isHtmlPopupVisible, setIsHtmlPopupVisible] = useState(false);
    const [HtmlMedia, setHtmlMedia] = useState(null);

    const [isQRCodePopupVisible, setIsQRCodePopupVisible] = useState(false);
    const [QRCodeMedia, setQRCodeMedia] = useState(null);

    const [isWeatherPopupVisible, setIsWeatherPopupVisible] = useState(false);
    const [WeatherMedia, setWeatherMedia] = useState(null);

    const [textMedia, setTextMedia] = useState(null); // New state for text media  
    const [mediapdf, Setmediapdf] = useState([]);
    const [isRssFeedPopupVisible, setIsRssFeedPopupVisible] = useState(false); // New state for Website popup
    const [RssMedia, setRssMedia] = useState(null);
    const [selectedMedia, setSelectedMedia] = useState(null);
    const [isClockPopupVisible, setIsClockPopupVisible] = useState(false);
    const [editClockMedia, setEditClockMedia] = useState(null);
    const [layoutDuration, setLayoutDuration] = useState(parsedLayout?.dur || 20);

    const [isYouTubePopupVisible, setIsYouTubePopupVisible] = useState(false);
    const [editYouTubeMedia, setYouTubeMedia] = useState(null);

    const [isRegionOptionsVisible, setIsRegionOptionsVisible] = useState(false);
    const [selectedRegion, setSelectedRegion] = useState({
        width: 0,
        height: 0,
        left: 0,
        top: 0,
        index: null,
        bgcolor: "",
    });

    const [layoutData, setLayoutData] = useState({
        "layoutId": props.id,
        "name": '',
        "xmlDesign": "",
        "createdBy": null,
    });

    useEffect(() => {
        GetResolution();
    }, []);

    async function GetResolution() {
        try {
            const data = await ResolutionListhooks();
            if (Array.isArray(data.items)) {
                getData(data.items);
            } else {
                console.error('Resolution data is not an array:', data);
            }
        } catch (err) {
            console.error('Error fetching resolutions:', err);
        }
    }

    async function getData(resolutions) {
        const data = await LayoutGetbyIdhooks(props.id);
        if (data !== undefined) {
            const parsedData = parseLayoutXML(data.xmlDesign);
            var currentresolution = resolutions.filter(x => x.resolutionId === data.resolutionId);

            setResolution(currentresolution[0]);
            setParsedLayout(parsedData);
            setLayoutDuration(parsedData.layout.duration);
            setLayoutData(data);
        }
        const imageMedia = await GetTypeContentListhooks('Image');
        Setmediaimages(imageMedia);
        const VideoMedia = await GetTypeContentListhooks('Video');
        Setmediavideos(VideoMedia);
        const pdfMedia = await GetTypeContentListhooks('PDF');
        Setmediapdf(pdfMedia);
    }
    if (!parsedLayout) {
        return <div>Loading...</div>;
    }

    const { layout, regions } = parsedLayout;

    const addRegion = () => {
        const newRegion = {
            class: `mediaNew${regions.length}`,
            width: 350,
            height: 350,
            top: 100,
            left: 100,
            color: '#cccccc',
            repeat: false,
            bgcolor: "",
            media: [],
        };
        setParsedLayout((prevState) => ({
            ...prevState,
            regions: [...prevState.regions, newRegion],
        }));
    };

    const deleteRegion = (index) => {
        if (window.confirm("Are you sure you want to delete this region?")) {
            const updatedRegions = [...regions];
            updatedRegions.splice(index, 1);
            setParsedLayout((prevState) => ({
                ...prevState,
                regions: updatedRegions,
            }));
        }
    };

    const handleTimelineClick = (currentRegionIndex) => {
        if (currentRegionIndex !== null) {
            const selectedRegion = regions[currentRegionIndex];

            SetCurrentRegionMedia(selectedRegion.media);
            SetRegionIndex(currentRegionIndex);
            toast.success('Region Timeline Selected!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };

    const handleImageButtonClick = (type) => {

        if (RegionIndex !== null) {
            if (type === 'Image') {
                SetcurrentpopupMedia(mediaimages)
            } else if (type === 'Video') {
                SetcurrentpopupMedia(mediavideos)
            } else if (type === 'PDF') {
                SetcurrentpopupMedia(mediapdf)
            }

            setIsPopupVisible(true);
        } else {
            toast.error('Please Select Region Timeline!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };

    const handlePopupClose = () => {
        setIsPopupVisible(false);
    };

    const handleImageSelect = (selectedImages) => {
        if (RegionIndex !== null && selectedImages.length > 0) {
            const updatedRegions = [...regions];
            selectedImages.forEach(image => {
                updatedRegions[RegionIndex].media.push({
                    type: image.type,
                    name: image.url,
                    title: image.title,
                    duration: 10, // Example duration
                    id: image.contentId
                });
            });

            setParsedLayout((prevState) => ({
                ...prevState,
                regions: updatedRegions,
            }));

            handleTimelineClick(RegionIndex);
        }
        setIsPopupVisible(false);
    };



    //clock function start

    const handleAddClock = () => {

        if (RegionIndex !== null) {
            setEditClockMedia(null); // For Add
            setIsClockPopupVisible(true);
        } else {
            toast.error('Please Select Region Timeline!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };

    const handleEditClock = (mediaIndex) => {
        const mediaToEdit = CurrentRegionMedia[mediaIndex];
        setEditClockMedia(mediaToEdit); // For Edit
        setIsClockPopupVisible(true);
    };

    const handleClockSave = (mediaData) => {
        const { id, name, style, format, offsetMinutes, timeZone, showSeconds } = mediaData;

        if (id) {
            // Editing existing Clock media
            const updatedMedia = [...CurrentRegionMedia];
            const updatedRegions = [...regions];
            const mediaIndex = updatedRegions[RegionIndex].media.findIndex((media) => media.id === id);

            if (mediaIndex !== -1) {
                const updatedClockMedia = {
                    ...updatedRegions[RegionIndex].media[mediaIndex],
                    name,
                    title: name,
                    style,
                    format,
                    offsetMinutes,
                    timeZone,
                    showSeconds,
                };

                updatedRegions[RegionIndex].media[mediaIndex] = updatedClockMedia;
                updatedMedia[mediaIndex] = updatedClockMedia;

                setParsedLayout((prevState) => ({
                    ...prevState,
                    regions: updatedRegions,
                }));

                SetCurrentRegionMedia(updatedMedia);
            }
        } else {
            // Adding new Clock media
            const newClockMedia = {
                type: 'Clock',
                name,
                title: name,
                duration: 10,
                style,
                format,
                offsetMinutes,
                timeZone,
                showSeconds,
                id: `clock${Date.now()}`,
            };

            SetCurrentRegionMedia((prevState) => [...prevState, newClockMedia]);
            regions[RegionIndex].media = [...CurrentRegionMedia, newClockMedia];
        }

        setIsClockPopupVisible(false);
    };


    //clock function End

    //Youtube Media Start

    const handleAddYoutube = () => {
        if (RegionIndex !== null) {
            setYouTubeMedia(null); // For Add 
            setIsYouTubePopupVisible(true);
        } else {
            toast.error('Please Select Region Timeline!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };

    const handleEditYoutube = (mediaIndex) => {
        const mediaToEdit = CurrentRegionMedia[mediaIndex];
        setYouTubeMedia(mediaToEdit); // For Edit
        setIsYouTubePopupVisible(true);
    };
    const handleYouTubeSave = (name, url, duration, autoplay, fullscreen, mediaId) => {
        const updatedMedia = [...CurrentRegionMedia];
        const updatedRegions = [...regions];

        if (mediaId) {
            const mediaIndex = updatedRegions[RegionIndex].media.findIndex(m => m.id === mediaId);
            if (mediaIndex !== -1) {
                updatedRegions[RegionIndex].media[mediaIndex] = {
                    ...updatedRegions[RegionIndex].media[mediaIndex],
                    name,
                    title: name,
                    url,
                    duration,
                    autoplay,
                    fullscreen
                };

                setParsedLayout(prev => ({ ...prev, regions: updatedRegions }));
                updatedMedia[mediaIndex] = { ...updatedMedia[mediaIndex], name, url, duration, autoplay, fullscreen };
                SetCurrentRegionMedia(updatedMedia);
            }
        } else {
            const newYouTubeMedia = {
                type: 'YouTube',
                name,
                title: name,
                url,
                duration,
                autoplay,
                fullscreen,
                id: `youtube${Date.now()}_${Math.floor(Math.random() * 10000)}`
            };

            const newMediaList = [...CurrentRegionMedia, newYouTubeMedia];
            SetCurrentRegionMedia(newMediaList);
            updatedRegions[RegionIndex].media = newMediaList;

            setParsedLayout(prev => ({ ...prev, regions: updatedRegions }));
        }

        setIsYouTubePopupVisible(false);
    };

    //youtube ENds

    const handleMediaEdit = (mediaIndex) => {
        const mediaToEdit = CurrentRegionMedia[mediaIndex];
        setEditingMedia(mediaToEdit);
        setIsEditPopupVisible(true);
    };

    const handleTextMediaEdit = (mediaIndex) => {
        const media = CurrentRegionMedia[mediaIndex];
        if (media.type === 'Text') {
            setTextMedia({ ...media, index: mediaIndex });
            setIsTextPopupVisible(true);
        }
    };



    const handleRssFeedButtonClick = () => {
        if (RegionIndex !== null) {
            setIsRssFeedPopupVisible(true);
        } else {
            toast.error('Please Select Region Timeline!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };

    const handleRSSFeedMediaEdit = (mediaIndex) => {

        const media = CurrentRegionMedia[mediaIndex];
        if (media.type === 'RssFeed') {
            setRssMedia({ ...media, index: mediaIndex });
            setIsRssFeedPopupVisible(true);
        }
    };

    const handleRSSFeedSave = ({ name, url, maxItems, duration, mediaId = null }) => {
        if (mediaId) {
            const updatedMedia = [...CurrentRegionMedia];
            const updatedRegions = [...regions];
            const mediaIndex = updatedRegions[RegionIndex].media.findIndex((media) => media.id === mediaId);
            if (mediaIndex !== -1) {
                updatedRegions[RegionIndex].media[mediaIndex] = {
                    ...updatedRegions[RegionIndex].media[mediaIndex],
                    text: url,
                    duration,
                    name,
                    title: name,
                    maxItems,
                };

                setParsedLayout((prevState) => ({
                    ...prevState,
                    regions: updatedRegions,
                }));

                updatedMedia[mediaIndex] = {
                    ...updatedMedia[mediaIndex],
                    text: url,
                    duration,
                    name,
                    title: name,
                    maxItems,
                };
                SetCurrentRegionMedia(updatedMedia);
            }
        } else {
            const newTextMedia = {
                type: 'RssFeed',
                name,
                duration: duration === null ? 10 : duration,
                text: url,
                id: `text${Date.now()}`,
                title: name,
                maxItems
            };

            SetCurrentRegionMedia((prevState) => [...prevState, newTextMedia]);
            regions[RegionIndex].media = [...CurrentRegionMedia, newTextMedia];
        }

        setIsRssFeedPopupVisible(false);
    };

    const handleEditSave = (updatedMedia) => {
        if (RegionIndex !== null) {
            const updatedRegions = [...regions];
            updatedRegions[RegionIndex].media = updatedRegions[RegionIndex].media.map(media =>
                media.id === updatedMedia.id ? updatedMedia : media
            );
            setParsedLayout((prevState) => ({
                ...prevState,
                regions: updatedRegions,
            }));
            SetCurrentRegionMedia(updatedRegions[RegionIndex].media);
            setIsEditPopupVisible(false);
        }
    };

    const handleEditPopupClose = () => {
        setIsEditPopupVisible(false);
    };

    const handleMediaDelete = (mediaIndex) => {
        if (window.confirm('Are you sure you want to delete this media item?')) {
            const updatedRegions = [...regions];
            updatedRegions[RegionIndex].media.splice(mediaIndex, 1);
            setParsedLayout((prevState) => ({
                ...prevState,
                regions: updatedRegions,
            }));
            SetCurrentRegionMedia(updatedRegions[RegionIndex].media);
        }
    };

    const handleTextButtonClick = () => {
        if (RegionIndex !== null) {
            setTextMedia(null);
            setIsTextPopupVisible(true);
        } else {
            setTextMedia(null);
            toast.error('Please Select Region Timeline!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };



    const handleTextSave = (name, textContent, size, color, mediaId, behave) => {
        if (mediaId) {
            // Editing an existing text media
            const updatedMedia = [...CurrentRegionMedia];
            const updatedRegions = [...regions];
            const mediaIndex = updatedRegions[RegionIndex].media.findIndex((media) => media.id === mediaId);
            if (mediaIndex !== -1) {
                updatedRegions[RegionIndex].media[mediaIndex] = {
                    ...updatedRegions[RegionIndex].media[mediaIndex],
                    text: textContent,
                    size,
                    color,
                    name,
                    title: name,
                    behave: behave,
                };

                setParsedLayout((prevState) => ({
                    ...prevState,
                    regions: updatedRegions,
                }));

                updatedMedia[mediaIndex] = {
                    ...updatedMedia[mediaIndex],
                    text: textContent,
                    size,
                    color,
                    name,
                    title: name,
                    behave: behave,
                };
                SetCurrentRegionMedia(updatedMedia);
            }
        } else {
            // Adding new text media
            const newTextMedia = {
                type: 'Text',
                name,
                duration: 10,
                size,
                color,
                behave: 'Center',
                title: name,
                text: textContent,
                id: `text${Date.now()}`,
            };

            SetCurrentRegionMedia((prevState) => [...prevState, newTextMedia]);
            regions[RegionIndex].media = [...CurrentRegionMedia, newTextMedia];
        }
        setIsTextPopupVisible(false);
    };


    const handleWebPageButtonClick = () => {
        if (RegionIndex !== null) {
            setWebsiteMedia(null);
            setIsWebsitePopupVisible(true);
        } else {
            toast.error('Please Select Region Timeline!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };

    const handleWebsiteMediaEdit = (mediaIndex) => {
        const media = CurrentRegionMedia[mediaIndex];
        if (media.type === 'Website') {
            setWebsiteMedia({ ...media, index: mediaIndex });
            setIsWebsitePopupVisible(true);
        }
    };

    const handleWebsiteSave = (name, Url, duration, mediaId) => {
        if (mediaId) {
            // Editing an existing text media
            const updatedMedia = [...CurrentRegionMedia];
            const updatedRegions = [...regions];
            const mediaIndex = updatedRegions[RegionIndex].media.findIndex((media) => media.id === mediaId);
            if (mediaIndex !== -1) {
                updatedRegions[RegionIndex].media[mediaIndex] = {
                    ...updatedRegions[RegionIndex].media[mediaIndex],
                    text: Url,
                    duration,
                    name,
                    title: name,
                };

                setParsedLayout((prevState) => ({
                    ...prevState,
                    regions: updatedRegions,
                }));

                updatedMedia[mediaIndex] = {
                    ...updatedMedia[mediaIndex],
                    text: Url,
                    duration,
                    name,
                    title: name
                };
                SetCurrentRegionMedia(updatedMedia);
            }
        } else {
            // Adding new Website media
            const newTextMedia = {
                type: 'Website',
                name,
                duration: duration === null ? 10 : duration,
                text: Url,
                id: `text${Date.now()}`,
                title: name
            };

            SetCurrentRegionMedia((prevState) => [...prevState, newTextMedia]);
            regions[RegionIndex].media = [...CurrentRegionMedia, newTextMedia];
        }
        setIsWebsitePopupVisible(false);
    };



    const handleWidgetButtonClick = (widgetType) => {

        if (RegionIndex !== null) {

            setSelectedMedia(null);

            switch (widgetType) {

                case "LiveStream":
                    setIsLiveStreamPopupVisible(true);
                    break;

                case "Countdown":
                    setIsCountdownPopupVisible(true);
                    break;

                case "Counter":
                    setIsCounterPopupVisible(true);
                    break;

                case "DateTime":
                    setIsDateTimePopupVisible(true);
                    break;

                case "HTML":
                    setIsHtmlPopupVisible(true);
                    break;

                case "QRCode":
                    setIsQRCodePopupVisible(true);
                    break;

                case "Weather":
                    setIsWeatherPopupVisible(true);
                    break;
            }

        }
        else {

            toast.error('Please Select Region Timeline!', {
                position: "top-right",
                autoClose: 5000
            });

        }

    };

    const handleWidgetMediaEdit = (mediaIndex) => {

        const media = CurrentRegionMedia[mediaIndex];
        console.log(media);

        if (!media)
            return;


        setSelectedMedia({
            ...media,
            index: mediaIndex
        });


        switch (media.type) {

            // case "Website":
            //     setIsWebsitePopupVisible(true);
            //     break;


            case "LiveStream":
                setIsLiveStreamPopupVisible(true);
                break;


            case "Countdown":
                setIsCountdownPopupVisible(true);
                break;


            case "Counter":
                setIsCounterPopupVisible(true);
                break;


            case "DateTime":
                setIsDateTimePopupVisible(true);
                break;


            case "HTML":
                setIsHtmlPopupVisible(true);
                break;


            case "QRCode":
                setIsQRCodePopupVisible(true);
                break;


            case "Weather":
                setIsWeatherPopupVisible(true);
                break;

        }

    };


    const handleWidgetSave = (widgetData) => {


        const {
            id,
            type,
            name
        } = widgetData;

        console.log(widgetData);

        let updatedRegions = [...regions];


        let updatedMedia = [...CurrentRegionMedia];



        if (id) {

            const mediaIndex =
                updatedRegions[RegionIndex]
                    .media
                    .findIndex(x => x.id === id);



            if (mediaIndex !== -1) {

                updatedRegions[RegionIndex].media[mediaIndex] =
                {
                    ...updatedRegions[RegionIndex].media[mediaIndex],
                    ...widgetData,
                    title: name
                };


                updatedMedia[mediaIndex] =
                {
                    ...updatedMedia[mediaIndex],
                    ...widgetData,
                    title: name
                };


            }

        }

        else {

            const newMedia =
            {
                ...widgetData,
                id: `${type}${Date.now()}`,

                type,

                title: name,

                name,

                duration: widgetData.duration ?? 10,                

            };


            updatedMedia.push(newMedia);


            updatedRegions[RegionIndex].media =
                updatedMedia;


        }



        SetCurrentRegionMedia(updatedMedia);


        setParsedLayout(prev => ({
            ...prev,
            regions: updatedRegions
        }));


        closeAllWidgets();

    };

    const closeAllWidgets = () => {

        //setIsWebsitePopupVisible(false);

        setIsLiveStreamPopupVisible(false);

        setIsCountdownPopupVisible(false);

        setIsCounterPopupVisible(false);

        setIsDateTimePopupVisible(false);

        setIsHtmlPopupVisible(false);

        setIsQRCodePopupVisible(false);

        setIsWeatherPopupVisible(false);

    };




    const saveLayout = async (e) => {
        const xmlDoc = create({ version: '1.0' })
            .ele('XML', { version: '0.0.1' })
            .ele('layout', { width: parsedLayout.layout.width, height: parsedLayout.layout.height, dur: layoutDuration, id: props.id });

        parsedLayout.regions.forEach(region => {
            const regionElement = xmlDoc.ele('region', {
                class: region.class,
                width: region.width,
                height: region.height,
                top: region.top,
                left: region.left,
                color: region.color,
                bgcolor: region.bgcolor,
                repeat: region.repeat
            });

            // url,

            // autoplay,
            // fullscreen,
            // region.media.forEach(media => {
            //     regionElement.ele('media', {
            //         type: media.type,
            //         name: media.name,
            //         dur: media.duration,
            //         id: media.id,
            //         size: media.size,
            //         color: media.color,
            //         behave: media.behave,
            //         text: media.text,
            //         style: media.style,
            //         format: media.format,
            //         offsetMinutes: media.offsetMinutes,
            //         timeZone: media.timeZone,
            //         showSeconds: media.showSeconds,
            //         url: media.url,
            //         autoplay: media.autoplay,
            //         fullscreen: media.fullscreen,
            //         title: media.title,
            //         maxItems: media.maxItems,
            //     }).txt(media.name);
            // });

            region.media.forEach(media => {
                const mediaAttrs = {};

                // Add only non-null, non-undefined, non-NaN values
                for (const [key, value] of Object.entries(media)) {
                    if (
                        value !== null &&
                        value !== undefined &&
                        !(typeof value === 'number' && isNaN(value))
                    ) {
                        mediaAttrs[key] = value;
                    }
                }

                regionElement.ele('media', mediaAttrs).txt(media.name);
            });

        });

        const xml = xmlDoc.end({ prettyPrint: true });
        layoutData.xmlDesign = xml;
        var res = await CreateLayouthooks(layoutData);
        if (res !== undefined) {
            toast.success('Design Saved successfully!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

        } else {
            toast.error('Design Saved Failed!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    };

    const generateRandomString = (length) => {
        const characters = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let randomString = '';
        for (let i = 0; i < length; i++) {
            randomString += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return randomString;
    };

    // Handle reordering when an item is dragged and dropped
    const handleOnDragEnd = (result) => {
        if (!result.destination) return;
        const items = Array.from(CurrentRegionMedia);
        const [reorderedItem] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, reorderedItem);
        SetCurrentRegionMedia(items);
        //setMediaItems(items);
        const updatedRegions = [...regions];
        regions[RegionIndex].media = items;
        setParsedLayout((prevState) => ({
            ...prevState,
            regions: updatedRegions,
        }));
    };

    const handleRegionOptions = (region, index) => {
        setSelectedRegion({
            index,
            width: region.width,
            height: region.height,
            left: region.left,
            top: region.top,
            bgcolor: region.bgcolor,
        });
        setIsRegionOptionsVisible(true);
    };



    return (
        <div className="container-fluid content-top-gap" style={{ minHeight: '600px' }}>
            <div className="container mb-2">
                <div className="row align-items-center">
                    {/* Left/Center section */}
                    <div className="col-md-10 text-center text-md-left">
                        <h4>
                            {props.name !== null ? 'Layout Name - ' + props.name : ''}
                        </h4>
                        <p>
                            <b>Layout Details - </b>
                            Aspect Ratio: 16:9 | Background Color: Black | Resolution Type: {resolution.resolutionType}
                        </p>
                    </div>

                    {/* Right section for buttons */}
                    <div className="col-md-2 text-right">
                        <Link className="btn btn-secondary" target='_blank' to={`/Demo/${props.id}`}>Preview</Link>

                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-sm-8">
                    <div className="container">
                        <div
                            id="layout"
                            layout_scale={resolution?.scale}
                            main_width={resolution.mainWidth}
                            main_height={resolution.mainHeight}
                            style={{
                                marginLeft: '1%',
                                position: 'relative',
                                width: resolution?.intentWidth + 'px',
                                height: resolution?.intentHeight + 'px',
                                backgroundColor: '#000000',
                            }}
                        >
                            {regions.map((region, index) => {
                                const regionid = generateRandomString(6);

                                // Calculate scaled values
                                const regionwid = Math.round(region.width * resolution.scale);
                                const regionhei = Math.round(region.height * resolution.scale);
                                const regiontop = Math.round(region.top * resolution.scale);
                                const regionleft = Math.round(region.left * resolution.scale);

                                return (
                                    <>
                                        <Draggable1
                                            key={regionid}
                                            defaultPosition={{ x: regionleft, y: regiontop }}
                                            onStop={(e, data) => {
                                                const updatedRegions = [...regions];
                                                updatedRegions[index].left = Math.round(data.x / resolution.scale);
                                                updatedRegions[index].top = Math.round(data.y / resolution.scale);
                                                setParsedLayout((prevState) => ({
                                                    ...prevState,
                                                    regions: updatedRegions,
                                                }));
                                            }}
                                            handle=".resize-handle"
                                            cancel=".layoutbtnline"
                                        >
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    width: regionwid,
                                                    height: regionhei,
                                                }}
                                            >
                                                <ResizableBox
                                                    width={regionwid}
                                                    height={regionhei}
                                                    minConstraints={[50, 50]}
                                                    maxConstraints={[resolution.intentWidth, resolution.intentHeight]}
                                                    className="resize-handle"
                                                    handle={<span className="resize-handle"></span>}
                                                    onResizeStop={(e, data) => {
                                                        const updatedRegions = [...regions];
                                                        updatedRegions[index].width = Math.round(data.size.width / resolution.scale);
                                                        updatedRegions[index].height = Math.round(data.size.height / resolution.scale);
                                                        setParsedLayout((prevState) => ({
                                                            ...prevState,
                                                            regions: updatedRegions,
                                                        }));
                                                    }}
                                                    style={{
                                                        position: 'absolute',
                                                        backgroundColor: 'rgba(0, 0, 0, 0.2)', // Adjust if needed
                                                    }}
                                                >
                                                    <div className="region ui-widget-content" style={{ width: '100%', height: '100%' }}>
                                                        <div className="layoutbtnline">
                                                            <button
                                                                className="laybtn module"
                                                                onClick={(e) => {
                                                                    e.preventDefault(); // Prevent default action
                                                                    e.stopPropagation(); // Stop event propagation
                                                                    handleTimelineClick(index);
                                                                }}
                                                            >
                                                                <i className="fa fa-window-restore fa-lg" aria-hidden="true"></i>
                                                            </button>
                                                            <button
                                                                className="laybtn option"
                                                                onClick={() => {
                                                                    // If you want to show in popup or state:
                                                                    handleRegionOptions(region, index); // optional function to open popup with these values
                                                                }}
                                                            >
                                                                <i className="fa fa-bars fa-lg" aria-hidden="true"></i>
                                                            </button>
                                                            <button
                                                                className="laybtn close"
                                                                style={{ border: '2px solid black', padding: '5px' }}
                                                                onClick={(e) => {
                                                                    e.preventDefault(); // Prevent default action
                                                                    e.stopPropagation(); // Stop event propagation
                                                                    deleteRegion(index);
                                                                }}
                                                            >
                                                                <i className="fa fa-trash fa-lg" aria-hidden="true"></i>
                                                            </button>

                                                        </div>

                                                        <p className="res mt-5 p-2">
                                                            {region.width}x{region.height}
                                                        </p>
                                                        {/* <h5 className='ml-4'>Current Media</h5> */}
                                                        {region.media.map((media, mediaIndex) => (
                                                            <div key={mediaIndex} className="media ml-4 ">
                                                                <p className='medianame'>{media.type} - {media.name}</p>
                                                                {/* <img
                                                                    src={`path/to/media/${media.name}`}
                                                                    alt={media.name}
                                                                    style={{ width: '100%', height: 'auto' }}
                                                                /> */}
                                                            </div>
                                                        ))}
                                                    </div>

                                                </ResizableBox>
                                            </div>
                                        </Draggable1>
                                    </>

                                );
                            })}
                        </div>
                    </div>
                    <div className='container-fluid content-top-gap'>
                        <div className='text-center'>
                            <button className="btn btn-primary" onClick={addRegion}>
                                Add Region
                            </button> &nbsp;
                            <button
                                className="btn btn-primary"
                                id="savepos"
                                onClick={saveLayout}
                            >
                                Save Layout
                            </button>
                            &nbsp;
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="row">
                        <div className='col-md-6'>
                            <label><strong>Layout Duration (in seconds):</strong></label>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-group">

                                <input
                                    type="number"
                                    className="form-control"
                                    value={layoutDuration}
                                    onChange={(e) => setLayoutDuration(Number(e.target.value))}
                                    placeholder="Enter duration"
                                    min={1}
                                />
                            </div>
                        </div>
                        <div className="col-md-12 col-sm-6 mb-4">

                            <div className='top-ads'>
                                <h4 className="text-center">Modules</h4>
                                <button className='btn btn-primary btn-sm btn-overline ml-2 mt-2' onClick={() => { handleImageButtonClick('Image') }}>Image</button>
                                <button className='btn btn-secondary btn-sm btn-overline ml-2 mt-2' onClick={() => { handleImageButtonClick('Video') }}>Video</button>
                                <button className='btn btn-success btn-sm btn-overline ml-2 mt-2' onClick={handleTextButtonClick}>Text</button>
                                <button className='btn btn-danger btn-sm btn-overline ml-2 mt-2' onClick={handleWebPageButtonClick}>Web Page</button>
                                <button className='btn btn-warning btn-sm btn-overline ml-2 mt-2' onClick={handleAddClock}>Clock</button>
                                <button className='btn btn-info btn-sm btn-overline ml-2 mt-2' onClick={handleAddYoutube}>YouTube</button>
                                <button className='btn btn-dark btn-sm btn-overline ml-2 mt-2' onClick={() => { handleImageButtonClick('PDF') }}>Pdf</button>
                                <button className='btn btn-light btn-sm btn-overline ml-2 mt-2' onClick={handleRssFeedButtonClick}>RSS Feed</button>
                                {/* <button className='btn btn-light btn-sm btn-overline ml-2 mt-2' onClick={() => handleWidgetButtonClick("Weather")}>Weather</button> */}
                                <button className='btn btn-light btn-sm btn-overline ml-2 mt-2' onClick={() => handleWidgetButtonClick("LiveStream")}>LiveStream</button>
                                <button className='btn btn-light btn-sm btn-overline ml-2 mt-2' onClick={() => handleWidgetButtonClick("Countdown")}>Countdown</button>
                                <button className='btn btn-light btn-sm btn-overline ml-2 mt-2' onClick={() => handleWidgetButtonClick("Counter")}>Counter</button>
                                <button className='btn btn-light btn-sm btn-overline ml-2 mt-2' onClick={() => handleWidgetButtonClick("DateTime")}>DateTime</button>
                                {/* <button className='btn btn-light btn-sm btn-overline ml-2 mt-2' onClick={() => handleWidgetButtonClick("HTML")}>HTML</button>
                                <button className='btn btn-light btn-sm btn-overline ml-2 mt-2' onClick={() => handleWidgetButtonClick("QRCode")}>QRCode</button> */}
                            
                            
                            
                            </div>
                            <div className="top-ads">
                                {RegionIndex !== null ? <h4 className="text-center"> TimeLine</h4> : ''}

                                {/* <div class="card card_border mt-1">
                                    <div class="card-body">
                                        <div className='row'>
                                            <div className='col-sm-8'>Type &nbsp; Name &nbsp;&nbsp; Duration </div>
                                            <div className='col-sm-4'>Actions</div>
                                        </div>
                                    </div>
                                </div> */}
                                <DragDropContext onDragEnd={handleOnDragEnd}>
                                    <Droppable droppableId="mediaList">
                                        {(provided) => (
                                            <ul
                                                className="media-list"
                                                {...provided.droppableProps}
                                                ref={provided.innerRef}
                                                style={{ listStyleType: "none", padding: 0 }}
                                            >
                                                {CurrentRegionMedia.map(({ id, type, name, duration, title }, mediaIndex) => (
                                                    <Draggable key={String(id)} draggableId={String(id)} index={mediaIndex}>
                                                        {(provided) => (
                                                            <li
                                                                ref={provided.innerRef}
                                                                {...provided.draggableProps}
                                                                {...provided.dragHandleProps}
                                                                style={{
                                                                    userSelect: "none",
                                                                    padding: "16px",
                                                                    margin: "0 0 8px 0",
                                                                    minHeight: "50px",
                                                                    backgroundColor: "#FFF",
                                                                    color: "#333",
                                                                    border: "1px solid #ccc",
                                                                    borderRadius: "4px",
                                                                    ...provided.draggableProps.style,
                                                                }}
                                                            >
                                                                {
                                                                    type === 'Image'
                                                                        ?
                                                                        <>
                                                                            <img
                                                                                src={`${FILE_BASE_URL}/${encodeURIComponent(name)}`}
                                                                                alt={title}
                                                                                style={{ width: '70px', height: '70px', objectFit: 'cover' }}
                                                                                className="img-thumbnail"
                                                                            />
                                                                            &nbsp;&nbsp;{title} - {duration} Seconds &nbsp;&nbsp;&nbsp;&nbsp;
                                                                        </>

                                                                        :
                                                                        <><strong>{type}:</strong> {title} - {duration} Seconds &nbsp;&nbsp;&nbsp;&nbsp;</>
                                                                }

                                                                {type === 'Image' || type === 'Video' || type === 'PDF' ?
                                                                    <button
                                                                        className="btn btn-warning mr-2"
                                                                        onClick={() => handleMediaEdit(mediaIndex)}
                                                                    >
                                                                        <i className="fa fa-edit" aria-hidden="true"></i>
                                                                    </button>
                                                                    : type === 'Text' ?
                                                                        <button
                                                                            className="btn btn-warning mr-2"
                                                                            onClick={() => handleTextMediaEdit(mediaIndex)}
                                                                        >
                                                                            <i className="fa fa-edit" aria-hidden="true"></i>
                                                                        </button>
                                                                        :
                                                                        type === 'Clock' ?
                                                                            <button className="btn btn-warning mr-2"
                                                                                onClick={() => handleEditClock(mediaIndex)}>
                                                                                <i className="fa fa-edit" aria-hidden="true"></i>
                                                                            </button>
                                                                            :
                                                                            type === 'YouTube' ?
                                                                                <button className="btn btn-warning mr-2"
                                                                                    onClick={() => handleEditYoutube(mediaIndex)}>
                                                                                    <i className="fa fa-edit" aria-hidden="true"></i>
                                                                                </button>
                                                                                : type === 'RssFeed' ?
                                                                                    <button className="btn btn-warning mr-2"
                                                                                        onClick={() => handleRSSFeedMediaEdit(mediaIndex)}>
                                                                                        <i className="fa fa-edit" aria-hidden="true"></i>
                                                                                    </button>
                                                                                    : type === 'Webiste' ?
                                                                                    <button className="btn btn-warning mr-2"
                                                                                        onClick={() => handleWebsiteMediaEdit(mediaIndex)}>
                                                                                        <i className="fa fa-edit" aria-hidden="true"></i>
                                                                                    </button>
                                                                                    :
                                                                                    <button className="btn btn-warning mr-2"
                                                                                        onClick={() => handleWidgetMediaEdit(mediaIndex)}>
                                                                                        <i className="fa fa-edit" aria-hidden="true"></i>
                                                                                    </button>
                                                                }

                                                                <button
                                                                    className="btn btn-danger"
                                                                    onClick={() => handleMediaDelete(mediaIndex)}
                                                                >
                                                                    <i className="fa fa-trash" aria-hidden="true"></i>
                                                                </button>
                                                            </li>
                                                        )}
                                                    </Draggable>
                                                ))}
                                                {provided.placeholder}
                                            </ul>
                                        )}
                                    </Droppable>
                                </DragDropContext>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {isPopupVisible && (
                <Popup
                    images={currentpopupMedia}
                    onSelect={handleImageSelect}
                    onClose={handlePopupClose}
                />
            )}{isEditPopupVisible && (
                <MediaEditPopup
                    media={editingMedia}
                    onSave={handleEditSave}
                    onClose={handleEditPopupClose}
                />
            )}
            {isTextPopupVisible && (
                <TextMediaPopup
                    onClose={() => setIsTextPopupVisible(false)}
                    onSave={handleTextSave}
                    media={textMedia} // Pass the text media being edited
                />
            )}
            {isWebsitePopupVisible && (
                <WebsitePopup
                    onClose={() => setIsWebsitePopupVisible(false)}
                    onSave={handleWebsiteSave}
                    media={WebsiteMedia} // Pass the text media being edited
                />
            )}
            {isClockPopupVisible && (
                <ClockMediaPopup
                    media={editClockMedia} // null for Add
                    onClose={() => setIsClockPopupVisible(false)}
                    onSave={handleClockSave}
                />
            )}

            {isYouTubePopupVisible && (
                <YoutubeMediaPopup
                    media={editYouTubeMedia} // null for Add
                    onClose={() => setIsYouTubePopupVisible(false)}
                    onSave={handleYouTubeSave}
                />
            )}
            {
                isRssFeedPopupVisible && (
                    <RSSFeedPopup
                        media={RssMedia}
                        onClose={() => setIsRssFeedPopupVisible(false)}
                        onSave={handleRSSFeedSave}
                    />
                )
            }

            {
                isWeatherPopupVisible &&

                <WeatherPopup
                    media={selectedMedia}
                    onSave={(data) =>
                        handleWidgetSave({
                            ...data,
                            type: "Weather"
                        })
                    }
                    onClose={closeAllWidgets}

                />

            }

            {
                isLiveStreamPopupVisible &&

                <LiveStreamPopup
                    media={selectedMedia}
                    onSave={(data) =>
                        handleWidgetSave({
                            ...data,
                            type: "LiveStream"
                        })
                    }
                    onClose={closeAllWidgets}

                />

            }

            {
                isCountdownPopupVisible &&

                <CountdownPopup
                    media={selectedMedia}
                    onSave={(data) =>
                        handleWidgetSave({
                            ...data,
                            type: "Countdown"
                        })
                    }
                    onClose={closeAllWidgets}

                />

            }

            {
                isCounterPopupVisible &&

                <CounterPopup
                    media={selectedMedia}
                    onSave={(data) =>
                        handleWidgetSave({
                            ...data,
                            type: "Counter"
                        })
                    }
                    onClose={closeAllWidgets}

                />

            }

            {
                isDateTimePopupVisible &&

                <DateTimePopup
                    media={selectedMedia}
                    onSave={(data) =>
                        handleWidgetSave({
                            ...data,
                            type: "DateTime"
                        })
                    }
                    onClose={closeAllWidgets}

                />

            }

            {
                isHtmlPopupVisible &&

                <HtmlPopup
                    media={selectedMedia}
                    onSave={(data) =>
                        handleWidgetSave({
                            ...data,
                            type: "HTML"
                        })
                    }
                    onClose={closeAllWidgets}

                />

            }

            {
                isQRCodePopupVisible &&

                <QRCodePopup
                    media={selectedMedia}
                    onSave={(data) =>
                        handleWidgetSave({
                            ...data,
                            type: "QRCode"
                        })
                    }
                    onClose={closeAllWidgets}

                />

            }

            {isRegionOptionsVisible && (
                <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Region Options</h5>
                                <button type="button" className="close" onClick={() => setIsRegionOptionsVisible(false)}>
                                    <span>&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="form-group">
                                    <label>Width</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={selectedRegion.width}
                                        onChange={(e) =>
                                            setSelectedRegion((prev) => ({ ...prev, width: parseInt(e.target.value) }))
                                        }
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Height</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={selectedRegion.height}
                                        onChange={(e) =>
                                            setSelectedRegion((prev) => ({ ...prev, height: parseInt(e.target.value) }))
                                        }
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Left</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={selectedRegion.left}
                                        onChange={(e) =>
                                            setSelectedRegion((prev) => ({ ...prev, left: parseInt(e.target.value) }))
                                        }
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Top</label>
                                    <input
                                        type="number"
                                        className="form-control"
                                        value={selectedRegion.top}
                                        onChange={(e) =>
                                            setSelectedRegion((prev) => ({ ...prev, top: parseInt(e.target.value) }))
                                        }
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Background Color</label>
                                    <input
                                        type="color"
                                        class="form-control input-style"
                                        value={selectedRegion.bgcolor}
                                        onChange={(e) =>
                                            setSelectedRegion((prev) => ({ ...prev, bgcolor: e.target.value }))
                                        }
                                    />
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-secondary" onClick={() => setIsRegionOptionsVisible(false)}>
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-primary"
                                    onClick={() => {
                                        const updatedRegions = [...regions];
                                        const idx = selectedRegion.index;

                                        updatedRegions[idx].width = selectedRegion.width;
                                        updatedRegions[idx].height = selectedRegion.height;
                                        updatedRegions[idx].left = selectedRegion.left;
                                        updatedRegions[idx].top = selectedRegion.top;
                                        updatedRegions[idx].bgcolor = selectedRegion.bgcolor;
                                        setParsedLayout((prev) => ({
                                            ...prev,
                                            regions: updatedRegions
                                        }));
                                        setIsRegionOptionsVisible(false);
                                    }}
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}

export default DesignComponent;